<template>
  <ResponsiveModal
    theme="error"
    :title="title"
    :description="description"
    :confirmLabel="confirmLabel || $t('components.buttons.delete')"
    :alignButtons="maxSmall ? 'center' : 'end'"
    @confirm="$emit('delete')"
  >
    <slot />
    <template #content>
      <div class="flex flex-col items-center p-4 md:pt-3">
        <span v-if="maxSmall">
          {{ description }}
        </span>
        <div class="flex flex-col items-center ltr:pl-2 rtl:pr-2">
          <ul
            v-if="hints"
            class="list-disc ltr:ml-3.5 rtl:mr-3.5 text-tertiary text-style-xs font-normal"
          >
            <li
              v-for="(hint, index) in hints"
              :key="index"
              class="text-tertiary text-style-xs font-normal"
            >
              {{ hint }}
            </li>
          </ul>
        </div>
      </div>
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxSmall } = useBreakpoints();

defineEmits(["delete"]);

defineProps({
  title: { type: String, required: false },
  description: { type: String, required: false },
  hints: { type: Array, required: false },
  confirmLabel: { type: String, required: false },
});
</script>
